import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import AuthGuard from './components/AuthGuard';
import Layout from './layout/Layout';
import ShipmentList from './pages/ShipmentList';
import ShipmentDashboard from './pages/ShipmentDashboard';
import CartonList from './pages/CartonList';
import CustomerManage from './pages/CustomerManage';
import CustomerAddresses from './pages/CustomerAddresses';
import CustomerShipments from './pages/CustomerShipments';
import RouteManage from './pages/RouteManage';
import TransportModeManage from './pages/TransportModeManage';
import ChannelManage from './pages/ChannelManage';
import CarrierManage from './pages/CarrierManage';
import AgentManage from './pages/AgentManage';
import AgentDepotList from './pages/AgentDepotList';
import AgentServiceList from './pages/AgentServiceList';
import AgentPriceQuery from './pages/AgentPriceQuery';
import AgentPriceDataManage from './pages/AgentPriceDataManage';
import SupplierManage from './pages/SupplierManage';
import SupplierContacts from './pages/SupplierContacts';
import ProductManage from './pages/ProductManage';
import OperationLogPage from './pages/OperationLogPage';
import ShipmentSlaThresholdPage from './pages/ShipmentSlaThresholdPage';
import ShipxyConfigPage from './pages/ShipxyConfigPage';
import LlmProviderManage from './pages/LlmProviderManage';
import BillingWeightRuleManage from './pages/BillingWeightRuleManage';

/** 图表库体积较大，价格趋势页按需加载 */
const AgentPriceTrend = React.lazy(() => import('./pages/AgentPriceTrend'));

const App: React.FC = () => (
  <BrowserRouter>
    <AuthGuard>
      <Routes>
        <Route path="/" element={<Layout />}>
        <Route index element={<Navigate to="/shipments/list" replace />} />
        {/* 运单管理 */}
        <Route path="shipments/list" element={<ShipmentList />} />
        <Route path="shipments/pre-declaration" element={<Navigate to="/shipments/list" replace />} />
        <Route path="shipments/handover" element={<ShipmentDashboard />} />
        <Route path="shipments/dashboard" element={<Navigate to="/shipments/handover" replace />} />
        {/* 货物管理 */}
        <Route path="warehouse/cartons" element={<CartonList />} />
        {/* 客户管理 */}
        <Route path="customers/list" element={<CustomerManage />} />
        <Route path="customers/addresses" element={<CustomerAddresses />} />
        <Route path="customers/shipments" element={<CustomerShipments />} />
        {/* 线路管理 */}
        <Route path="routes/transport-modes" element={<TransportModeManage />} />
        <Route path="routes/list" element={<RouteManage />} />
        <Route path="routes/channels" element={<ChannelManage />} />
        <Route path="routes/carriers" element={<CarrierManage />} />
        <Route path="routes/billing-weight-rules" element={<BillingWeightRuleManage />} />
        {/* 代理管理 */}
        <Route path="agents/list" element={<AgentManage />} />
        <Route path="agents/depots" element={<AgentDepotList />} />
        <Route path="agents/services" element={<AgentServiceList />} />
        <Route path="agents/price-query" element={<AgentPriceQuery />} />
        <Route
          path="agents/price-trend"
          element={
            <React.Suspense fallback={<Spin style={{ display: 'block', marginTop: 80 }} />}>
              <AgentPriceTrend />
            </React.Suspense>
          }
        />
        <Route path="agents/price-data" element={<AgentPriceDataManage />} />
        {/* 供应商管理 */}
        <Route path="suppliers/list" element={<SupplierManage />} />
        <Route path="suppliers/contacts" element={<SupplierContacts />} />
        {/* 产品管理 */}
        <Route path="products/list" element={<ProductManage />} />
        {/* 系统 */}
        <Route path="system/operation-logs" element={<OperationLogPage />} />
        <Route path="system/shipment-sla-thresholds" element={<ShipmentSlaThresholdPage />} />
        <Route path="system/shipxy-config" element={<ShipxyConfigPage />} />
        <Route path="system/llm-providers" element={<LlmProviderManage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </AuthGuard>
  </BrowserRouter>
);

export default App;
